import React from 'react'
import Layout from '../components/Page.layout'

const MePage = props => <Layout {...props}>Me page...</Layout>
export default MePage
